/* @flow */
/* eslint-disable camelcase */
/* eslint-disable babel/no-invalid-this */
import type { WindowShadeSetPercentOpenFeature } from "./types";

export default function WindowShadeSetPercentOpen(
  feature: WindowShadeSetPercentOpenFeature
) {
  const setPercentOpenAction = feature.actions.set_percent_open;

  this.setPercentOpen = (newValue) => {
    return this.executeDeviceAction(setPercentOpenAction, {
      percent_open: newValue,
    });
  };

  return { percent_open: feature.percent_open };
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/window_shade_set_percent_open.js